module.exports = "<button class=\"btn btn-pur btn-default\">Emoji</button>"


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/JointlyWebService/admin/CollabspaceAdminPortal/src/app/customClass/app-emoji/app-emoji.component.html
// module id = ../../../../../src/app/customClass/app-emoji/app-emoji.component.html
// module chunks = main